<template lang="pug">
  v-tabs(slider-color="primary" color="white")
    v-tab(v-for="item in filteredRoles" :key="item.title" :to="{ name: item.route }")
      |{{ item.title }}
</template>

<script>

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    baseRoutes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: null,
    }
  },
  mounted() {
    if (this.baseRoutes.includes(this.$route.name)) {
      this.openFirstBlock();
    }
  },
  methods: {
    closeAll() {
      this.$refs.item.map(it => { it.open = false; })
    },
    openFirstBlock(menu = this.menu) {
      return menu.some(it => {
        if (this.hasCorrectRoles(it)) {
          this.$router.push({ name: it.route });
          return true;
        } else {
          return false;
        }
      });
    },
    hasCorrectRoles(branch) {
      // return !branch.permissions || !branch.permissions.length || branch.permissions.every(it => !!this.$store.state.app.user.roles.find(x => x.name === it));
      return true;
    },
  },
  computed: {
    filteredRoles() {
      return this.menu.filter(it => {
        return this.hasCorrectRoles(it);
      });
    },
  },
}
</script>

<style lang="scss">
  .embedded-nav {
    margin-top: 1px;
  }
  .fixed-nav-branch {
    position: absolute;
    width: 100%;
    z-index: 2;
  }
</style>
